import { useLang } from "@/context/LanguageContext";
import { scrollToSection as scrollTo } from "@/lib/scroll";
import Reveal from "./Reveal";
import { ArrowRight } from "lucide-react";

const BG =
  "https://images.pexels.com/photos/28264496/pexels-photo-28264496.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1600";

export default function CtaBand() {
  const { t } = useLang();
  return (
    <section className="relative py-20 md:py-24 bg-ksy-navy overflow-hidden" data-testid="cta-band">
      <img src={BG} alt="Semi truck on highway" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-ksy-navy/85" />
      <div className="absolute inset-0 bg-gradient-to-r from-ksy-navy via-ksy-navy/80 to-transparent" />
      <Reveal className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
        <h2 className="font-display font-extrabold text-3xl md:text-5xl text-white tracking-tight">{t("cta.title")}</h2>
        <p className="mt-4 text-lg text-blue-100/80">{t("cta.subtitle")}</p>
        <button
          onClick={() => scrollTo("quote")}
          className="mt-8 inline-flex items-center gap-2 bg-white text-ksy-navy font-bold px-8 py-4 rounded-lg hover:bg-blue-50 transition-colors shadow-lg"
          data-testid="cta-band-button"
        >
          {t("cta.button")} <ArrowRight className="w-5 h-5" />
        </button>
      </Reveal>
    </section>
  );
}
